import { useEffect } from 'react';

// Encapsulates all auto-calc effects for the Create/Edit Order form:
//   1. Circumference   = height × ups_in_circum
//   2. Length          = (width × ups_in_length) + trimming + extra_length
//   3. Nos of cylinders = new_baseshell + pbs
//   4. Job name         = joined manufacturing + brand + qty + packed_date + barcode
export const useOrderFormDerived = (orderData, setOrderData) => {
  // Circumference + Length
  useEffect(() => {
    const height = parseFloat(orderData.height) || 0;
    const width = parseFloat(orderData.width) || 0;
    const upsInCircum = parseFloat(orderData.ups_in_circum) || 0;
    const upsInLength = parseFloat(orderData.ups_in_length) || 0;
    const trimming = parseFloat(orderData.trimming) || 0;
    const extraLength = parseFloat(orderData.extra_length) || 20;
    const circumference = height * upsInCircum;
    const length = (width * upsInLength) + trimming + extraLength;
    setOrderData(prev => ({
      ...prev,
      circumference: circumference > 0 ? circumference.toFixed(2) : '',
      length: length > 0 ? length.toFixed(2) : '',
    }));
  }, [orderData.height, orderData.width, orderData.ups_in_circum, orderData.ups_in_length, orderData.trimming, orderData.extra_length, setOrderData]);

  // Nos of Cylinders = BS + PBS
  useEffect(() => {
    const bs = parseInt(orderData.new_baseshell, 10) || 0;
    const pbs = parseInt(orderData.pbs, 10) || 0;
    const total = bs + pbs;
    if (total > 0) {
      setOrderData(prev => ({ ...prev, nos_of_cylinders: String(total) }));
    }
  }, [orderData.new_baseshell, orderData.pbs, setOrderData]);

  // Auto-generate Job Name
  useEffect(() => {
    const formatDateForJobName = (dateString) => {
      if (!dateString) return '';
      const d = new Date(dateString);
      return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getFullYear()).slice(-2)}`;
    };
    const parts = [
      orderData.manufactured_by,
      orderData.marketed_by,
      orderData.brand_name,
      orderData.product_name,
      orderData.qty,
      orderData.packed_date ? formatDateForJobName(orderData.packed_date) : '',
      orderData.bar_code,
    ].filter(part => part && String(part).trim() !== '');
    const generated = parts.join('_');
    if (generated) setOrderData(prev => ({ ...prev, job_name: generated }));
  }, [orderData.manufactured_by, orderData.marketed_by, orderData.brand_name, orderData.product_name, orderData.qty, orderData.packed_date, orderData.bar_code, setOrderData]);
};
